import Vue from 'vue'
import VueResource from 'vue-resource'
import settings from '@/settings'

Vue.use(VueResource)

let apiUrl = settings.apiUrl
let version = settings.version

export default {
  GET_USER_DATA: ({ commit, dispatch }, to) => {
    return new Promise((resolve, reject) => {
      Vue.http.get(`${apiUrl}${version}/users/info`).then(res => {
        commit('SET_USER', res.body)
        commit('SET_ROLES', [res.body.role])
        resolve()
      }, err => {
        reject(err)
      })
    })
  }
}



// WEBPACK FOOTER //
// ./src/store/user/actions.js